import React from "react";
import TextImage from "./Text-image";
import reading from "../images/Reading.png";
import bridge from "../images/Bridge.png";
import pointcloudcams from "../images/PointCloudCams.png";

function More() {
  return (
    <div id="Implementation" className="more-container">
      <hr></hr>
      

        <section className="content">
        <div className="image-container-left">
          <img src={reading} alt="" />
          <p className="caption">
            View of the digital recreation of the Stanza della Segnatura with a book in hand.
          </p>
        </div>

        <div className="text text-container-right white-background">
          <p>
            The Immersive Raphael Project is a platform to reflect on and communicate the embodied experience of a room like the Stanza della Segnatura as a functional complex: How can we understand the act of reading in the Renaissance that takes place in the room; how did discourse structures work at the time? To tackle these questions, we decided to build a tool that allows us and people with related interests to analyze and think beyond the typically isolated representations of the frescos on one side, the books on another, the Vatican architecture on yet another. How can we create a complete scene that allows us to "experience" and reflect on all of these aspects together, in the way they used to exist and were conceived? This was the foundational question that led us to create a virtual reconstruction of the room with its books and context.
          </p>
      
        </div>
      </section>

      <TextImage
        string1="right"
        string2="left"
        object3={bridge}
        caption="The 3D recponstruction embedded in a Scalar page, connected through the Unity-Scalar bridge."
        string4="Since its creation, the uses and arrangements of the Stanza della Segnatura — and many of the other rooms in the Vatican — have changed multiple times, rooms have been redecorated, repurposed, rebuilt. This means that, if we want to understand a specific moment in history and understand it from a more comprehensive point of view that includes the actions, environments and the tangible life reality of a certain historic moment, we can only approach that moment in a digital reconstruction. We do not have much sense of how people were reading in the Renaissance. We might know what they were reading, who was reading, and maybe why, but we do not have a sense of the embodied act of reading, how people may have been engaging with others, how reading was part of an active discourse etc. The reconstruction in a virtual environment gives us a chance to begin to think about these important aspects of the intellectual history and culture."
      />

      <section className="content">
        <div className="image-container-left">
          <img src={pointcloudcams} alt="" />
          <p className="caption">
              Calculation of a 3-dimensional point cloud of the Stanza della Segnatura.
          </p>
        </div>

        <div className="text text-container-right white-background">
          <h4>Reconstructing Reading</h4>
          <br></br>
          <p>
            In building the engine for the Immersive Raphael Project we are aiming to balance the immersiveness of the experience and the ease of engaging into a discourse about the room and its practices. Is a virtual representation of the room that is as realistic as possible the right approach - or should the experience be more like an editable media text that is always ready to take annotations and allow references? Our decision was to combine the two aspects as good as possible: We built an immersive recreation of the room using point-cloud scan of the actual room, running in a game engine that allows users to explore the room at will, pick up books, walk around with them and see how the pages catch the light shining through the windows. This interactive scene is embedded in a scholarly writing environment called Scalar, which allows to read and edit in a comfortable way as we are used to doing it on our computer screens. A specifically developed software bridge that connects Unity and Scalar establishes a bi-directional data flow between these two components. In this setup we can combine the hyper-textual links we know from the web with the hyperlinks of the Renaissance that connect physical books across the room with frescos and other books.
            </p>
          <br></br>
        </div>
      </section>

<section className="more-content">
        <div id="visit">
          <a href="https://scalar.usc.edu/works/digital-stanza-della-segnatura/index">
            Visit the Immersive Raphael Project
          </a>
        </div>


        <div className="more-section">
          <ul className="reference">
            <h1>External Links:</h1>
            <br></br>

            <li>
              <a href="https://drive.google.com/file/d/1cEncfXLsC_L7L5vT8wm9fla3CzFTDO2k/view?usp=drive_link">
                Frederic Nolan Clark on Renaissance reading
              </a>
            </li>

            <li>
              <a href="https://drive.google.com/file/d/1fZ8ebLld0oaAq-ceJ-7jRM1VEK-BkUdl/view?usp=drive_link">
                Tracy Cosgriff on Raphael’s portraits of books
              </a>
            </li>

            <li>
              <a href="https://drive.google.com/file/d/1NEym7JkaGeOQ8bDM0uU1IudYy00Hx8or/view?usp=drive_link">
                Andreas Kratky on designing the Bibliotheca Iulia Instaurata
              </a>
            </li>

            <li>
              <a href="https://drive.google.com/file/d/13wFp4Vod_ZH_vMXJ62rgWGYY1tIRO_5x/view?usp=drive_link">
                Lisa Pon on the Stanza della Segnatura as library
              </a>
            </li>

            <li>
              <a href="https://digi.vatlib.it/search?k_f=0&k_v=vat.lat.1125">
                Vatican Library Digitized: DigiVatLib.it
              </a>
            </li>

            <li>
              <a href="https://www.nortonsimon.org/learn/watch-and-listen/videos-podcasts-and-lectures/lecture-raphael-2020-a-conversation-on-the-artist/">
                Norton Simon’s Raphael 2020 Conversation
              </a>
            </li>

            <li>
              <a href="https://www.museivaticani.va/content/museivaticani/en/collezioni/musei/tour-virtuali-elenco.html">
                Vatican Museums’ 360-degree Virtual Tours
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default More;
